import { useEffect } from 'react';
import { buildUrlFromPage } from './navigationUtils';

// Custom hook for managing Telegram WebApp back button
export const useBackButton = (navigationStack, setAppLocation) => {
  useEffect(() => {
    const currentPage = navigationStack[navigationStack.length - 1];
    
    if (!currentPage) return;

    const handleBackClick = () => {
      let previousUrl = '/home';
      if (navigationStack.length > 1) {
        // Go to previous page in stack
        const previousPage = navigationStack[navigationStack.length - 2];
        previousUrl = buildUrlFromPage(previousPage);
      }
      // previousUrl += (previousUrl.indexOf('?') === -1 ? '?' : '&') + 'back=true';
      setAppLocation(previousUrl);
    };

    if (currentPage.type === 'home') {
      // Hide back button on home page
      window.Telegram.WebApp.BackButton.hide();
      window.Telegram.WebApp.BackButton.offClick(handleBackClick);
    } else if (currentPage.type === 'sub') {
      // SubLeagues handles its own back button logic - don't interfere
      // Just ensure it's shown, but don't override click handler
      window.Telegram.WebApp.BackButton.show();
    } else {
      // Show back button on all other pages
      window.Telegram.WebApp.BackButton.show();
      window.Telegram.WebApp.BackButton.onClick(handleBackClick);
    }

    return () => {
      if (currentPage.type !== 'sub') {
        window.Telegram.WebApp.BackButton.offClick(handleBackClick);
      }
    };
  }, [navigationStack, setAppLocation]);
};